import { ensureDate } from "@/other/dateTime/format";

export function dateDescendingSortCompare<T>(
    dateGetter: (object: T) => Date | undefined,
    idGetter: (object: T) => string
) {
    return (a: T, b: T) => {
        const aDate = dateGetter(a);
        const bDate = dateGetter(b);
        const aTime = aDate
            ? ensureDate(aDate).getTime()
            : Number.MAX_SAFE_INTEGER;
        const bTime = bDate
            ? ensureDate(bDate).getTime()
            : Number.MAX_SAFE_INTEGER;
        if (aTime === bTime) {
            if (idGetter(a) > idGetter(b)) {
                return 1;
            } else {
                return -1;
            }
        } else if (aTime < bTime) {
            return 1;
        } else {
            return -1;
        }
    };
}

export function stringAscendingSortCompare<T>(
    stringGetter: (object: T) => string | undefined,
    idGetter: (object: T) => string
) {
    return (a: T, b: T) => {
        const compareResult = (stringGetter(a) ?? idGetter(a)).localeCompare(
            stringGetter(b) ?? idGetter(b)
        );
        if (compareResult > 0) return 1;
        if (compareResult < 0) return -1;

        return 0;
    };
}
